import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "src/app/Services/ToastrService/toastr.service";
import { IUserConfig } from "src/app/Models/Interface/Auth/user-config";
import { UserConfigService } from "src/app/Services/AuthService/user-config.service";
import { DataService } from "../Services/DataService/data.service";
import { APIName } from "../Models/APIEndPoints/APIName";
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  user = {} as IUserConfig;
  checkedAuth: boolean = false;

  constructor(
    private cookieService: CookieService,
    private router: Router,
    private toastrService: ToastrService,
    private userConfigService: UserConfigService,
    private dataService: DataService
  ) {
    this.userConfigService.getUserConfig().subscribe((res) => {
      this.user = res;
    });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.user.token) {
      if (!this.checkedAuth)
        this.isLoggedIn().subscribe((res) => {
          this.checkedAuth = true;

          // if (res) {
          // } else {
          //   this.cookieService.delete("token");
          //   this.router.navigate(["auth", "sign-in"]);
          // }
        });

      // console.log(this.user.token);

      return true;
    } else {
      this.router.navigate(["auth", "sign-in"]);
      // localStorage.removeItem('isLogedIn')
      // this.toastrService.errorAlert('Not Authorized Please Login', 'Error!!');
      return false;
    }
  }

  // check if user is logged in
  isLoggedIn(): Observable<any> {
    let params = new HttpParams();
    return this.dataService.getWithParams(APIName.auth.checkAuth, params);
  }
}
